<script lang="ts">
import { useDesignStore } from '@/stores/designStore.ts'

import { computed, ref } from 'vue'

import CustomModal from '@/components/CustomModal.vue'
import _ from 'lodash'
import DropdownSelect from '@/components/DropdownSelect.vue'
import { ManualSkill, useSkillStore } from '@/stores/skillsStore.ts'
import IconDisplay from '@/components/IconDisplay.vue'
import { getListFromArray } from '@/Utility.ts'
import { storeToRefs } from 'pinia'

export default {
  props: ['skill'],
  emits: ['baseSelected'],
  setup(props, context) {
    const designStore = useDesignStore()
    const subSkillModal = ref(false)
    const skillStore = useSkillStore()
    const { allSkills } = storeToRefs(skillStore)
    const skill3 = ref((props.skill.subSkills && props.skill.subSkills[0]) || '')
    const skill5 = ref((props.skill.subSkills && props.skill.subSkills[1]) || '')
    const skill7 = ref((props.skill.subSkills && props.skill.subSkills[2]) || '')
    const skill9 = ref((props.skill.subSkills && props.skill.subSkills[3]) || '')
    const isComplete = computed(() => {
      if (props.skill.rank >= 9) {
        return props.skill.subSkills?.length === 4
      } else if (props.skill.rank >= 7) {
        return props.skill.subSkills?.length === 3
      } else if (props.skill.rank >= 5) {
        return props.skill.subSkills?.length === 2
      } else if (props.skill.rank >= 3) {
        return props.skill.subSkills?.length === 1
      } else {
        return true
      }
    })
    const subSkillList = computed(() => {
      let val: ManualSkill[] = allSkills.value.filter(
        (skill: ManualSkill) => skill.skill === props.skill.skill
      )
      return val[0].subSkills
    })
    function update(num: number, val: string) {
      let subskills = props.skill.subSkills || []
      switch (num) {
        case 3:
          if (skill3.value) {
            subskills[0] = val
          } else subskills = [val]
          skill3.value = val
          break
        case 5:
          if (skill5.value) {
            subskills[1] = val
          } else subskills = [skill3.value, val]
          skill5.value = val
          break
        case 7:
          if (skill7.value) {
            subskills[2] = val
          } else subskills = [skill3.value, skill5.value, val]
          skill7.value = val
          break
        case 9:
          if (skill9.value) {
            subskills[3] = val
          } else subskills = [skill3.value, skill5.value, skill7.value, val]
          skill9.value = val
          break
      }
      console.log(subskills)
      skillStore.updateSubSkills(props.skill.skill, subskills)
    }

    return {
      designStore,
      subSkillModal,
      update,
      props,
      isComplete,
      getListFromArray,
      allSkills,
      skill3,
      skill5,
      skill7,
      skill9,
      subSkillList
    }
  },
  components: {
    DropdownSelect,
    CustomModal,
    IconDisplay
  }
}
</script>
<template>
  <div
    @click="subSkillModal = true"
    style="display: flex; flex-direction: column; justify-content: center; padding-bottom: 0.5rem"
  >
    <div v-if="isComplete" style="padding-left: 0.25rem">
      {{ getListFromArray(props.skill.subSkills || []) }}
    </div>

    <div
      v-else
      @click="subSkillModal = true"
      style="align-items: center"
      class="hoverableTransparantLinear"
    >
      <div style="display: flex; width: 100%">
        <div style="padding-left: 0.25rem">
          {{ getListFromArray(props.skill.subSkills || []) }}
        </div>
        <IconDisplay
          style="padding-left: 0.25rem"
          scale="1"
          icon="gi-upgrade"
          :style="{ color: designStore.alertTheme }"
          class="pulse"
        ></IconDisplay>
      </div>
    </div>

    <CustomModal
      :showModal="subSkillModal"
      title="Select Sub Skills"
      @close="subSkillModal = false"
    >
      <template v-slot:body>
        <div>
          <i>Sub Skills</i> are specializations in specific aspects of skills. A
          <i>Sub Skills</i> may be more relevant to a check and be easier for someone with that
          <i>Sub Skill</i>. <i>Sub Skills</i> also count as unique skills for
          <b>Skill Challenges</b>.
        </div>
        <DropdownSelect
          :default="skill3"
          header="Rank 3 Unlock"
          :overrideDown="true"
          :squared="true"
          :writeIn="true"
          :disabled="skill.rank < 3"
          :options="
            subSkillList.filter(
              (skill) => skill != skill3 && skill != skill5 && skill != skill7 && skill != skill9
            )
          "
          class="subSkillSelect"
          @selection="(val) => update(3, val)"
        ></DropdownSelect>
        <DropdownSelect
          :default="skill5"
          header="Rank 5 Unlock"
          :disabled="skill.rank < 5"
          :squared="true"
          class="subSkillSelect"
          :writeIn="true"
          :options="
            subSkillList.filter(
              (skill) => skill != skill3 && skill != skill5 && skill != skill7 && skill != skill9
            )
          "
          @selection="(val) => update(5, val)"
        ></DropdownSelect>
        <DropdownSelect
          :disabled="skill.rank < 7"
          header="Rank 7 Unlock"
          :default="skill7"
          :squared="true"
          class="subSkillSelect"
          :writeIn="true"
          :options="
            subSkillList.filter(
              (skill) => skill != skill3 && skill != skill5 && skill != skill7 && skill != skill9
            )
          "
          @selection="(val) => update(7, val)"
        ></DropdownSelect>
        <DropdownSelect
          :default="skill9"
          header="Rank 9 Unlock"
          @selection="(val) => update(9, val)"
          :disabled="skill.rank < 9"
          :squared="true"
          class="subSkillSelect"
          :writeIn="true"
          :options="
            subSkillList.filter(
              (skill) => skill != skill3 && skill != skill5 && skill != skill7 && skill != skill9
            )
          "
        ></DropdownSelect>
      </template>
    </CustomModal>
    <br />
  </div>
</template>
<style>
.subSkillSelect {
  margin: 0.5rem;
  z-index: 10;
}

@keyframes jingle {
  0% {
    transform: scale(1);
    /* box-shadow: 0 0 20px 20px; */
  }
  10% {
    transform: scale(1.1) rotate(10deg);
  }
  20% {
    transform: scale(1.2) rotate(-10deg);
  }
  30% {
    transform: scale(1.3) rotate(10deg);
  }
  40% {
    transform: scale(1.4) rotate(-10deg);
  }
  50% {
    transform: scale(1.5) rotate(10deg);
  }
  60% {
    transform: scale(1.4) rotate(-10deg);
  }
  70% {
    transform: scale(1.3) rotate(10deg);
  }
  80% {
    transform: scale(1.2) rotate(-10deg);
  }
  90% {
    transform: scale(1.1) rotate(10deg);
  }
  100% {
    transform: scale(1);
  }
}
.pulse {
  border-radius: 1rem;
  animation: jingle 2s infinite;
}
</style>
